//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import SwoopLogo from './SwoopLogo'
import AccountMenu from '@/components/AccountMenu'
import Dialog from '@/components/Dialog'
import Masquerade from '@/components/Masquerade'
export default {
  name: 'Navigation',
  components: {
    Masquerade,
    AccountMenu,
    SwoopLogo,
    Dialog
  },
  data() {
    return {
      routes: [
        { label: 'Services', icon: '/img/icons/services.svg', to: '/services' },
        { label: 'Quotes', icon: '/img/icons/quotes.svg', to: '/quotes' },
        { label: 'Billing', icon: '/img/icons/billing.svg', to: '/billing' },
        { label: 'Support', icon: '/img/icons/support.svg', to: '/support' }
      ],
      showMasqueradeDialog: false
    }
  }
}
